var buttonReset = '_19xx72g0';

export { buttonReset };
//# sourceMappingURL=button-reset.css.js.map
